
export default {
  data() {
    return {
      pressed: false
    }
  },
  methods: {
    down() {
      this.pressButton();
    },
    up() {
      this.unPressButton();
    },
    leave() {
      this.unPressButton();
    },
    pressButton() {
      this.pressed = true;
    },
    unPressButton() {
      this.pressed = false;
    }
  }
}



// WEBPACK FOOTER //
// ./components/mixins/Button.vue